<template>
  <div class="app-content-wrapper">
    <div class="search-wrapper">
      <search-component ref="search"
                        :search-buttons="searchButtons"
                        :fuzzySearchPlaceholder="$t('message.permission.roleName')"
                        :fuzzySearchKey="'roleName'"
                        router-name="/account/permission/role">
      </search-component>
    </div>
    <div class="table-wrapper">
      <custom-table :table-set="tableCondition"
                    :service-function="getRoleList"
                    ref="table"
                    router-name="/account/permission/role">
                    <template #roleName="{ row }">
                      <div class="role-name-box">
                        <span>{{row.roleName}}</span>
                        <!-- <span>
                          <el-popover
                            :visible-arrow="false"
                            popper-class="permission-popover"
                            trigger="click"
                            @show="handleShowPermission(row.id)">
                            <PermissionPopover :info="permissionInfo"></PermissionPopover>
                            <i class="iconfont icon-wenhao" slot="reference"></i>
                          </el-popover>
                        </span> -->
                      </div>
                    </template>
      </custom-table>
    </div>
    <custom-message ref="customMessage"></custom-message>
    <role-edit
      ref="roleEditModal"
      :title="editModalTitle"
      :edit="isEdit"
      :data='editRole'
      @onSuccess="editSuccessHandler"></role-edit>
    <role-add :visible="showAddDrawer" @close="showAddDrawer = false" @refresh="refreshTable"></role-add>
  </div>
</template>
<script>
import CustomMessage from '@/components/modal/message-box/custom-message.vue';
import CustomTable from '@/components/table/custom-table.vue';
import SearchComponent from '@/components/table/search-component.vue';
import { getCurrentMenu } from '@/layout/base/components/inavbar/utils';
import {
  getRoleList, deleteRole, getRoleIsUsed, getRoleNames,
  getRoleDetail,
} from '@/views/account/permission/api/role';
// import PermissionPopover from '@/views/account/permission/permission-popover/index.vue';
import RoleAdd from '@/views/account/permission/role/add/index.vue';
import RoleEdit from '@/views/account/permission/role/edit/index.vue';

export default {
  components: {
    CustomTable,
    SearchComponent,
    CustomMessage,
    RoleEdit,
    RoleAdd,
    // PermissionPopover,
  },
  data() {
    return {
      searchButtons: [
        {
          type: 'add',
          name: this.$t('message.permission.addRole'),
          permissionCode: 'account:permission:role:add',
          func: () => {
            this.showAddDrawer = true;
          },
        },
      ],
      tableCondition: [
        { // 角色名
          titleBar: { type: 'text', title: 'message.permission.roleName' },
          key: 'roleName',
          type: 'slot',
        },
        { // 更新时间
          titleBar: { type: 'text', title: 'message.tableCommon.updateTime' },
          key: 'updateTime',
          type: 'text',
        },
        { // 状态
          titleBar: { type: 'text', title: 'message.tableCommon.status' },
          key: 'statusName',
          type: 'tag',
          itemWidth: 100,
          tagTypeFunc: (data) => (`${data.status}` === '1' ? 'success' : 'warning'),
        },
        { // 更新时间
          titleBar: { type: 'operations', title: 'message.tableCommon.operation' },
          key: 'buttons',
          type: 'operations',
          subTableDisplays: [
            { // 详情
              type: 'text_button',
              permissionCode: 'account:permission:role:view',
              textFunc: () => 'message.tableCommon.details',
              func: (data) => {
                this.$router.push({ path: '/account/permission/role/view', query: { id: data.id } });
              },
            },
            { // 编辑
              type: 'text_button',
              // permissionCode: 'account:permission:role:edit',
              textFunc: () => 'message.tableCommon.edit',
              func: (data) => {
                this.$router.push({ path: '/account/permission/role/view', query: { id: data.id, flag: 1 } });
              },
            },
            // { // 编辑
            //   type: 'text_button',
            //   permissionCode: 'account:permission:role:edit',
            //   textFunc: () => 'message.tableCommon.edit',
            //   func: (data) => {
            //     this.$router.push({ path: '/account/permission/role/view', query: { id: data.id } });
            //   },
            // },
            { // 删除
              type: 'text_button',
              permissionCode: 'account:permission:role:delete',
              textFunc: () => 'message.tableCommon.delete',
              func: (data) => {
                const loading = this.$loading();
                getRoleIsUsed(data.id).then((res) => {
                  let message = `${this.$t('message.permission.deleteRoleConfirm')}?`;
                  if (res === true) {
                    message = `${this.$t('message.permission.deleteUsedRoleConfirm')}?`;
                  }
                  // 确认框
                  this.$refs.customMessage.openHttpModal({
                    titleHtml: this.$t('message.common.prompt'),
                    contentHtml: message,
                    httpFunction: this.deleteRole,
                    params: data.id,
                    successFunction: this.refreshTable,
                  }, 'warn');
                  loading.close();
                }).catch(() => {
                  loading.close();
                });
              },
            },
          ],
        },
      ],
      editModalTitle: 'message.permission.editRole',
      isEdit: false,
      editRole: null,
      permissionMap: {},
      permissionInfo: {},
      showAddDrawer: false,
    };
  },
  beforeCreate() {
    try {
      const menu = getCurrentMenu(this.$store.getters.permission.menus, {
        path: '/account/permission',
        meta: {
          resourceCode: 'account:permission',
          permissionType: 'menu',
        },
      });
      const index = menu.childrenNode[0].menuUrl;
      if (index !== '/account/permission/role') {
        this.$router.push({ path: index });
      }
    } catch (err) {
      //
    }
  },
  created() {
    // getRoleNames().then((res) => {
    //   this.searchCondition[0].options = res;
    // });
  },
  methods: {
    getRoleList,
    deleteRole,
    refreshTable() {
      this.$refs.table.refreshTable();
    },
    editSuccessHandler() {
      this.refreshTable();
    },
    async handleShowPermission(roleId) {
      this.permissionInfo = {};
      if (!this.permissionMap[roleId]) {
        this.permissionMap[roleId] = await getRoleDetail(roleId);
      }
      this.permissionInfo = this.permissionMap[roleId];
    },
  },
};
</script>
<style lang="scss" scoped>
.role-name-box {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 200px;
  padding-right: 4px !important;
  font-family: Avenir-Heavy, Avenir;
  font-weight: 800;
  color: #264373;

  .icon-wenhao {
    cursor: pointer;
  }
}
</style>

<style lang="scss">
.permission-popover {
  min-width: 364px;
  padding: 25px !important;
  padding-top: 8px !important;
  background: #FFFFFF;
  box-shadow: 0px 0px 20px 10px rgba(0,0,0,0.05);
  border-radius: 4px;
}
</style>
